/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.feather = require('feather-icons');
require('./partials/utils.js');
require('./partials/load-more-bar.js');
require('./partials/footer.js');
require('./partials/navigation.js');
require('./partials/rankings.js');
require('./partials/scroll-to-top.js');
require('./partials/forms.js');
require('./partials/misc.js');
require('./partials/expand-text.js');
require('./partials/tab-selector.js');
require('./partials/copy-to-clipboard.js');
// require('./partials/ad-resize.js');
require('./partials/search-filters.js');
require('./partials/forum-login.js');
// window.Vue = require('vue');

// custom feather icons
const IconConstructor = window.feather.icons.activity.constructor;

window.feather.icons.rankings = new IconConstructor(
  'rankings',
  `
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="belt" transform="translate(1.000000, 6.000000)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <ellipse cx="11.0418182" cy="5.488" rx="6.86" ry="5.488"></ellipse>
        <path d="M4.96590909,2.94 C1.81108719,2.94 0.233676235,2.94 0.233676235,2.94 C-0.111087045,3.24774536 -0.0428336868,8.15306885 0.233676235,8.428 C0.233676235,8.428 1.81108719,8.428 4.96590909,8.428" id="Path-3"></path>
        <path d="M21.9761825,2.94 C18.8036199,2.94 17.2173386,2.94 17.2173386,2.94 C16.911837,3.24774536 16.9723177,8.15306885 17.2173386,8.428 C17.2173386,8.428 18.6151136,8.428 21.4106636,8.428" id="Path-3-Copy" transform="translate(19.493228, 5.684000) rotate(-180.000000) translate(-19.493228, -5.684000) "></path>
    </g>
    <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
</g>
  `,
);

window.feather.icons.twitternew = new IconConstructor(
  'twitternew',
  '<path d="M1.05353 2L9.54748 13.0311L1 22H2.92385L10.4073 14.1475L16.4535 22H23L14.028 10.3485L21.984 2H20.0601L13.1685 9.23182L7.6 2H1.05353ZM3.88263 3.37629H6.89005L20.1705 20.6237H17.1631L3.88263 3.37629Z" fill="currentColor"/>',
);

window.feather.replace();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*
const app = new Vue({
    el: '#app'
});
*/
